module.exports = __webpack_public_path__ + "static/img/252_TO8_2241_og.d0b7570.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/252_TO8_2241_og.jpg
// module id = wF/r
// module chunks = 0